import FR from './FR';
import { OriginShippingCountries } from './shippingRates.types';
import { ShippingService } from './shippingRates.types';

export const shippingRatesByFromLocation: Record<OriginShippingCountries, ShippingService[]> = {
    FR: FR,
} as const;

export { getShippingServicesForPackage } from './getShippingServicesForPackage';